module.exports = __webpack_public_path__ + "static/media/gearIcon.93cd8a90.svg";